<template>
  <div class="messageframe">
    <!-- <div v-if="messages && (messages.length === 0)">
      <md-empty-state
        md-icon="textsms"
        md-label="No messages"
        md-description="No messages yet.">
      </md-empty-state>
    </div> -->
    <div class="messages" v-if="messages && messages.length" id="messageswindow" ref="messageswindow" v:onscroll="{ this.scrolled=true }">
      <div v-for="message in messages" v-bind:key="message.sid">
        <md-card md-with-hover v-bind:class="getFloat(message.direction)">
          <md-card-header>
            {{ message.body }}
            <span class="messagemedia" v-if="message.mediaUrl">
              <img :src="message.mediaUrl">
            </span>
          </md-card-header>
          <md-card-content>
            {{ message.dateSent | readableTime }}
            {{ message.from }}
          </md-card-content>
          <md-icon :class="configArrow(message.direction)">play_arrow</md-icon>
        </md-card>
      </div>
    </div>
    <div v-else>
      <md-empty-state
        md-icon="textsms"
        md-label="Loading..."
        md-description="Loading messages...">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </md-empty-state>
    </div>
    <div class="outgoing md-alignment-bottom-center">
      <md-field>
        <label>Outgoing:</label>
        <md-textarea v-model="outgoing" md-counter="500" class="md-field outgoing" v-on:keyup.enter="sendMessage()"></md-textarea>
        <md-button class="md-fab md-mini" v-on:click="sendMessage()">
          <md-icon>send</md-icon>
        </md-button>
      </md-field>
    </div>
    <!-- <md-button class="md-fab md-mini md-fab-top-right" v-on:click="getMessages()">
      <md-icon>refresh</md-icon>
      <md-tooltip md-direction="top">Refresh Conversation</md-tooltip>
    </md-button> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  data () {
    return {
      messages: null,
      endpoint: 'https://api.cvstech.com/twilio/messages/',
      sendEndpoint: 'https://api.cvstech.com/twilio/sendmessage',
      outgoing: '',
      scrolled: false
    }
  },
  computed: {
    ...mapState([
      'userfirstname',
      'userlastname',
      'useremail',
      'usercolor',
      'userlevel',
      'userTwilioAccountSID',
      'teamTwilioAccountSID',
      'teamTwilioAuthToken',
      'teamTwilioSMSNumber',
      'teamname',
      'teamlastupdate',
      'teamlastcommfrom'
    ]),
    ...mapFields([
      'selectedcontactSMS',
      'forceConversationUpdate'
    ])
  },
  methods: {
    getMessages () {
      console.log('Getting messages... ' + this.teamTwilioSMSNumber + '/' + this.selectedcontactSMS)
      if (this.teamTwilioAccountSID) {
        axios.post(this.endpoint + this.teamTwilioSMSNumber + '/' + this.selectedcontactSMS, {
          sid: this.teamTwilioAccountSID,
          token: this.teamTwilioAuthToken
        })
          .then(response => {
            this.messages = response.data
            console.log(this.messages)
          })
          .catch(error => {
            console.log('-----error-------')
            console.log(error)
          })
      } else {
        console.log('State data not ready yet...')
      }
      this.updateScroll()
      console.log(this.messages)
    },
    getFloat (direction) {
      var computedFloat
      computedFloat = (direction === 'inbound' ? 'left md-accent' : 'right md-primary')
      // console.log("Computed Float: " + computedFloat);
      return computedFloat
    },
    configArrow (direction) {
      var computedArrowConfig
      computedArrowConfig = (direction === 'inbound' ? 'arrowin' : 'arrowout')
      return computedArrowConfig
    },
    updateScroll () {
      var elem = document.getElementById('messageswindow')
      if (elem) {
        elem.scrollTop = elem.scrollHeight
      }
    },
    sendMessage () {
      axios.post(this.sendEndpoint,
        {
          sid: this.teamTwilioAccountSID,
          token: this.teamTwilioAuthToken,
          to: this.selectedcontactSMS,
          body: this.outgoing,
          from: this.teamTwilioSMSNumber
        })
        .catch(error => {
          console.log('-----error-------')
          console.log(error)
        })
      this.messages.push({
        body: this.outgoing,
        dateSent: Date.now() / 1000,
        direction: 'outbound-api',
        from: this.teamTwilioSMSNumber,
        mediaURL: '',
        sid: '',
        status: 'unknown',
        to: this.selectedcontactSMS,
        url: ''
      })
      // setTimeout(this.forceConversationUpdate = true, 2000)
      this.outgoing = ''
    }
  },
  updated () {
    this.updateScroll()
  },
  watch: {
    selectedcontactSMS: function (newdata, olddata) {
      this.messages = []
      console.log('Selected contact changed')
      // console.log('old: ' + olddata + ' new: ' + newdata)
      this.getMessages()
    },
    teamlastupdate: function (newdata, olddata) {
      console.log('Last update refreshed.')
      this.getMessages()
    },
    forceConversationUpdate: function (newdata, olddata) {
      this.forceConversationUpdate = false
      this.getMessages()
    }
  }
}
</script>

<style scoped>

  .messagesframe {
    height: 100%;
    flex-direction: column;
  }

  .messages {
    flex: 1 0 auto;
    overflow-y: scroll;
    height: calc(100vh - 254px);
  }

  .md-card {
    /* max-width: 600px;
    min-width: 450px; */
    width: 75%;
    margin: 15px;
    display: inline-block;
    vertical-align: top;
    position: relative;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .outgoing {
    flex-shrink: 0;
    height: 100px;
    font-size: 12pt;
    line-height: normal;
  }

  .arrowout {
    position: absolute;
    top: 10px;
    right: -16px;
    height: 24px;
    width: 24px;
    color: #448aff !important;
  }

  .arrowin {
    position: absolute;
    top: 10px;
    left: -16px;
    height: 24px;
    width: 24px;
    color: #ff5252 !important;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  .md-empty-state {
    height: calc(100vh - 236px);
  }
</style>



// WEBPACK FOOTER //
// src/components/Conversation.vue